<template>
  <div class="page">
    <div v-for="(item, i) in data">
      <div class="margin-top" v-if="item.strong == true">
        <strong> {{ item.title }}</strong>
      </div>
      <div class="margin-top" v-else>{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillUserRule",
  data() {
    return {
      data: [

        {
          title:
            "欢迎您使用工匠码平台服务!"
        },
        { title: "本协议系由您 (或称“用户”)与(或称“我们”之间就平台(以下或简称“平台”)服务而签订。" },
        {title:"在使用平台服务之前，请您务必审慎阅读、充分理解本协议(如果您未满 16 周岁，或已满 16 周岁未满 18 周岁且不能以自己的劳动收入作为主要收入来源的，请在法定监护人的陪同下阅读本协议) 各项条款，特别是限制或免除责任条款、隐私保护政策、帐号规则、法律适用和争议解决条款(包括管辖条款)，以及其它以加粗加黑和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。若您不同意本协议，则您有充分且完全的权利退出使用平台服务(但这并不妨碍您浏览平台中的信息)，您通过网络页面点击注册和/或实际使用平台服务的行为即视为您已阅读、理解并同意接受本协议。如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您通过本协议所附联系方式与我们沟通反馈，我们十分乐意为您解答。"},
        {title:"1.基础约定",strong:true},
        {title:"1.1.协议范围:考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面的界定您与平台之间的权利义务，本协议包括我们根据法律法规规定以及本协议制定的其他政策、规则、公告声明等(除非特有所指，合称为“本协议”)，您也应当加以遵守"},
        {title:"1.2.服务范围:我们可能通过不断丰富的功能界面向您提供本协议项下的平台服务，包括但不限于移动应用程序 (“APP”)、PC 端网站、小程序以及其他形式具体以我们实时发布的服务功能界面范围为准。"},
        {title:"1.3.修改与更新:我们有权遵照法律法规规定，在必要时修改本协议 (包括适时制定并发布其他政策、规则、公告声明)，更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用平台服务的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止使用平台服务。"},
        {title:"1.4.平台授予用户一项个人的、不可转让及免费使用(除本协议另有声明外) 的许可，以供您使用平台服务，用户可以以非商业目的使用。"},
{title:"2.本平台服务内容",strong:true},
{title:"2.1.作为人才生态的构建者，我们致力于建立更受职场人喜爱的职场发展平台和更受企业信赖的人才平台。我们向用户提供的服务，包括但不限于网络招聘、校园招聘、海外招聘、人才发展、人才测评、服务外包、职场社区等产品及服务，为企业和职场人提供一站式的人才招聘服务，提高职场竞争力并实现自我价值。请您理解并知悉我们的服务可能会根据您的需求或公司运营的需要不时调整更新，请以我们网页或相关移动客户端的服务项目为准。"},
{title:"2.2.我们为您展示/提供个性化的职位检索服务，您可以根据需要设置自己的筛选检索标准，在寻找合适的职位招聘信息的同时可以节省许多找工作的时间。但请您理解并同意，由于互联网信息的海量，我们无法保证第三方招聘方上传、分享的招聘信息的真实性、合法性和有效性，请您在向第三方投递简历，面试邀约的过程中您应自行审慎判断其真实性和可靠性，请勿轻易透露您的个人信息，特别是个人敏感信息。除法律法规明确规定外，您应对因该等信息而实施的行为负责。"},
{title:"2.3.当您购买我们的任何付费服务前，例如在简历修改服务，请您仔细阅读付费服务涉及到的特殊条款，我们会在您付款前给与您明确的付款提示，当涉及到第三方服务提供商提供的服务时，您需要参阅第三方服务提供商的用户协议及产品规则。"},
{title:"2.4.我们提供的部分产品或服务中可能包含了评价功能，您可通过我们的评价功能对您曾经任职及现在任职的企业做出评价，方便其他用户更全面地了解招聘单位。"},
{title:"2.5.您理解并同意，为向您提供更全面、更便利的招聘服务，我们及我们的关联公司可能通过短信、电子邮件的方式向您推送有关招聘活动的专场活动信息、职位信息等信息(包括商业信息或非商业信息)。此外，为了使您在求职过程中能实时了解求职进展，我们可能向您推送消息。如果您不想接受我们以任何方式向您推送的信息，您可以选择收回您的授权同意。您可以通过我们在电子邮件中的退订按钮或按照我们在短信中提供的退订说明进行退订。需要说明的是，当涉及到系统管理或安全信息等事关您使用服务或信息安全的重要事项时，我们仍会向您推送该信息，以确保您能够顺畅使用平台服务。"}
,{title:"2.6.平台服务是求职招聘类服务，我们的服务仅面向具备法定劳动资格的自然人(18 周岁以上的成年人，也包括 16 周岁以上且以自己的劳动收入为主要生活来源的未成年人) 如您不属于本条所规定的用户范畴，请退出并关闭本平台服务。"}
,{title:"3.用户账号规则",strong:true}
 ,{title:"3.1.因平台主要提供人力资源服务，您在注册或使用平台服务时可能需要提供一些必要的信息。您须保证所填写及所提供的资料真实、准确、完整，否则可能无法使用平台服务，或在使用过程中受到限制，甚至影响您是否能够使用平台特定功能。对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您承担。"},{
   title:"3.2.平台有权根据您所提供资料的真实性、准确性、完整性以及是否符合平台服务规定的其他条件，决定是否为您提供服务。 您在使用平台服务过程中，所提供的信息发生变动，应及时进行变更。"
 },{title:"3.3.您注册成功后，我们将为您配置帐号，该帐号之所有权归平台所有，用户在本协议有效期内仅享有使用权。未经平台同意，用户的帐号仅供用户本人使用，帐号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用。"}
 ,{title:"3.4.您知悉并理解，如不同帐号绑定或关联同一手机号、同一支付账户、同一身份证信息、同一设备号或相同收货信息，所述不同帐号将可能被视为关联帐号(即同一用户)，在此情况下，我们有权进行合并或强制注销相关帐号。"}
 ,{title:"3.5.如果您需要注销您的帐号，您有权通过平台公布的方式、程序进行，我们将在核实您的身份并清理帐号资产(例如已充值或已获得的虚拟资产等) 及纠纷争议后，为您提供帐号注销服务。在注销帐号之后本协议即终止，我们将停止为您提供任何服务。当然，我们也保留权利在您的帐号符合回收的如下情况下，直接回收并注销您的帐号并停止服务:a.未通过实名认证;b.连续 12个月未曾登陆、使用平台服务:c.其它情况。"}

 ,{title:"3.6.用户一经注册，即可能可以在平台及我们关联公司运营的其它产品，或者合作伙伴等第三方平台中通行使用。在使用平台服务帐号登录并使用其他产品或服务时，除遵守本协议约定外，还应遵守该等产品的服务协议的约定。平台服务和其他产品对可能出现的纠纷在法律规定和约定的范围内各自承担责任。"}
 ,{title:"3.7.为客户体验及功能服务考虑，您在使用不同服务时被要求填写的信息内容可能不完全一致，因此，在使用更高级别服务时，为了给您提供更好的服务及为了您的登录帐号安全，可能需要您补充完整信息后方可使用。"}
 ,{title:"3.8.您有责任自行负责保管账号的用户名和密码等信息，否则因该等事项引发的法律责任由用户自行承担。凡使用平台服务登录帐号和登录凭证的行为，平台服务视为您本人的操作，操作所产生的电子信息记录均为平台服务用户行为的有效凭据。"},
 {title:"4.用户行为规范",strong:true},
 {title:"4.1.您保证合理地使用平台服务，并接受本协议和我们适时制定并发布的其他政策、规则、公告声明。"}
 ,{title:"4.2.行为禁止:您可在本协议约定的范围内使用平台及服务，您不得利用平台从事以下行为:"}
 ,{title:"(1)超出授权或恶意使用平台服务;"}
 ,{title:"(2)利用平台发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等；"}
 ,{title:"(3)利用平台侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益;"}
 ,{title:"(4)恶意虚构或协助虚构事实、评价等信息或数据；"}
,{title:"(5)进行任何危害计算机网络安全的行为，包括但不限于:使用未经许可的数据或进入未经许可的服务器/账户;未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息;未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为;企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;伪造 TCP/IP 数据包名称或部分名称;利用平台及服务上传任何病毒、木马或者蠕虫等危害网络健康的内容;"}
  ,{title:"(6)对平台进行反向工程、反向编译或反向汇编或以其它方式企图发现平台的源代码和算法，未经许可修改、禁用软件的任何功能或创建基于软件的衍生作品。去除平台或文档上的任何所有权声明或标签，或将其他软件与平台合并；"}
  ,{title:"(7)进行任何破坏我们提供服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用 BUG(又叫“漏洞”或者“缺陷”)来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG 公之于众;"}
  ,{title:"(8)从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。"}
 ,{title:"4.3.信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。用户亦承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”"}
 ,{title:"4.3.1.我们鼓励您制作、复制、发布含有下列内容的信息:"}
,{title:"(1)宣传习近平新时代中国特色社会主义思想，全面准确生动解读中国特色社会主义道路、理论、制度、文化的;"}
,{title:"(2) 宣传党的理论路线方针政策和中央重大决策部署的;"}
  ,{title:"(3) 展示经济社会发展亮点，反映人民群众伟大奋斗和火热生活的;"}
  ,{title:"(4)弘扬社会主义核心价值观，宣传优秀道德文化和时代精神，充分展现中华民族昂扬向上精神风貌的;"}
  ,{title:"(6) 有助于提高中华文化国际影响力，向世界展现真实立体全面的中国的;"}
  ,{title:"(7)其他讲品味讲格调讲责任、讴歌真善美、促进团结稳定等的内容。"}
  ,{title:"4.3.2.您不得制作、复制、发布含有下列内容的违法信息:"}
  ,{title:"(1)反对宪法所确定的基本原则的;"}
  ,{title:"(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；"}
  ,{title:"(3)损害国家荣誉和利益的；"}
  ,{title:"(4)歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的;"}
  ,{title:"(5)宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的;"}
  ,{title:"(6)煽动民族仇恨、民族歧视，破坏民族团结的；"}
  ,{title:"(7)破坏国家宗教政策，宜扬邪教和封建迷信的；"}
  ,{title:"(8)散布谣言，扰乱经济秩序和社会秩序的;"}
  ,{title:"(9)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;"}
  ,{title:"(10)侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；"}
  ,{title:"(11) 法律、行政法规禁止的其他内容。"}
  ,{title:"4.3.3.我们也将依法采取措施，防范和抵制制作、复制、发布含有下列内容的不良信息:"}
  ,{title:"(1)使用夸张标题，内容与标题严重不符的；"}
  ,{title:"(2)炒作绯闻、丑闻、劣迹等的;"}
  ,{title:"(3)不当评述自然灾害、重大事故等灾难的;"}
  ,{title:"(4)带有性暗示、性挑逗等易使人产生性联想的；"}
  ,{title:"(5)展现血腥、惊悚、残忍等致人身心不适的;"}
  ,{title:"(6)煽动人群歧视、地域歧视等的;"}
  ,{title:"(7)宣扬低俗、庸俗、媚俗内容的;"}
  ,{title:"(8)可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的;"}
  ,{title:"(9)其他对网络生态造成不良影响的内容。"}
  ,{title:"4.4.信息内容的使用规范:未经我们书面许可，您不得自行或授权、允许、协助任何第三人对平台中信息内容进行如下行为:"}
  ,{title:"(1)复制、读取、采用平台的信息内容，用于任何形式的商业用途；"}
  ,{title:"(2)擅自编辑、整理、编排平台及相关服务的信息内容后在平台及相关服务的源页面以外的渠道进行展示;"}
  ,{title:"(3) 采用不正当方式，自行或协助第三人对平台及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。"}
  ,{title:"5.个人信息保护与隐政策",strong:true}
  ,{title:"5.1.尊重用户隐私并保护您的个人信息安全是我们的一贯态度，平台将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得用户同意，平台不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于提供服务之外的目的。"}
  ,{title:"5.2.安全保护:我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息及隐私安全，以免遭受未经授权的访问、使用或披露。"}
  ,{title:"5.3.信息使用与披露:我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在我们的非公开内容。您同意并保证:平台有权根据我们制定的个人信息保护规则收集使用您的相关信息。"}
  ,{title:"5.4.您同意，我们有权通过 cookie 等技术收集您的使用、行为信息，并在经过数据脱敏使之不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。当然，您也可根据自己的偏好删除 Cookic，但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。目前删除 Cookie 的一般路径是浏览器:“设置清除数据”，或者将手机系统还原/清除。"}
  ,{title:"5.5.在遵守本协议项下特别约定的个人信息保护与隐私政策外，我们希望您认真并完整阅读我们特别针对平台而制定并适时发布的《隐私权政策》，这将更有助于保障您的个人信息。"}
  ,{title:"6.知识产权权益",strong:true}
  ,{title:"6.1.我们对平台中所包含的受知识产权或其他法律保护的资料享有相应的权利;除依法由用户享有著作权的内容之外，平台的整体内容的知识产权归我们或关联公司所有。"}
  ,{title:"6.2.您在使用我们服务时利用平台及服务所发表上传的文字、图片、视频、软件以及表演等原创信息的知识产权归您所有 (或由第三方内容提供方和您另行约定)，但是基于平台运营的需求，您确认您对该等信息的发表、上传行为视同为对我们投权知识产权的使用、复制、传播等权利。"}
  ,{title:"6.3.基于对数据的合法加工而获得的具有竞争性的数据权益，除法律法规另有规定外，我们享有独立的使用权益而无须获得您的同意。"}
  ,{title:"6.4.关于信息内容的投诉或举报。若您在使用平台过程中，不慎受到合法权益的侵犯，您有权通知我们采取必要措施进行处置。若您在使用平台过程中，发现存在违法违规或违反本服务相关规则的情况，您也有权向我们发起举报，我们亦会及时采取必要措施(删除、屏蔽、断开链接或限制使用功能等) 进行处置。"}
  ,{title:"6.5.内容维权授权。在法律法规允许的范围内，您同意并授权我们就侵犯您合法权益的行为(包括但不限于私自复制、使用、编辑、抄袭等行为) 采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。"}
  ,{title:"7.免责声明",strong:true},
  {title:"7.1.我们对于您自平台而获得的所有他人、第三方的信息(包括招聘方)、内容或者广告宣传等任何资讯(以下统称“信息”)，除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在接受平台及服务时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，我们均不对任何此等内容承担任何责任。无论何种原因，我们不对任何非与我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。"}
  ,{title:"7.2.鉴于互联网服务的特殊性，您理解并同意我们在以下情况下无需对您所遭受的损失(包括但不限于财产、收益、数据资料等方面的损失或其它无形损失) 承担责任："},
  {title:"(1)因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致平台及服务障碍不能正常运作;"}
  ,{title:"(2)由于计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或故障、系统维护等意外原因而造成平台及服务中断或延迟。"}
  ,{title:"8.违约责任",strong:true}
  ,{title:"8.1.如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。"}
  ,{title:"8.2.若您的行为给我们造成损失的(包括但不限于直接损失、名誉损失、第三方的罚款、索赔等)，我们有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，我们有权冻结。"}
  ,{title:"8.3.本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利:根据法律规定，继续保存您留存于平台的的各类信息;对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。"}
  ,{title:"9.法律适用与管辖",strong:true}
  ,{title:"9.1.本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。"}
  ,{title:"9.2.如双方就平台服务协议内容或其履行发生任何争议，双方应尽力友好协商解决;协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。"}
  ,{title:"10.如何联系我们",strong:true}
  ,{title:"10.1.如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下:"}
  ,{title:"客服热线:19801109882"}
  ,{title:"客服邮箱:hzf-4c8ml7ncz@dingtalk.com"}
 ]}},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}

div {
  color: #666;
  font-size: 0.34rem;
  text-align: left;
  width: 100%;
  line-height: 0.6rem;
  font-weight: normal;
  letter-spacing: 1px;
}

.margin-top {
  margin-top: 0.3rem;
}

.center {
  font-size: 0.36rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  text-align: center;
  color: #000;
}

.right {
  font-size: 0.36rem;
  color: #666;
  width: 100%;
  margin-top: 0.6rem;
  float: right;
  text-align: right;
  margin-bottom: 0.6rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/SkillUserRule.vue